
import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import ServicesSection from '../components/ServicesSection';
import WorkProcessSection from '../components/WorkProcessSection';
import SkillSection from '../components/SkillSection';
import WhyChooseUsSection from '../components/WhyChooseUsSection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import ScrollingTicker from '../components/ScrollingTicker';

function Home() {
  return (
    <div className="home-page">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WorkProcessSection />
      <SkillSection />
      <WhyChooseUsSection />
      <TestimonialsSection />
      <FAQSection />
      <ScrollingTicker />
    </div>
  );
}

export default Home;
